import { Smartphone, ShieldCheck, FileSignature, PackageCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n";

const ITEMS = [
  { icon: Smartphone, k: "access" },
  { icon: ShieldCheck, k: "security" },
  { icon: FileSignature, k: "digital" },
  { icon: PackageCheck, k: "protected" },
];

const Card = ({ item, i }) => {
  const Icon = item.icon;
  return (
    <Reveal delay={i * 0.08} className="h-full">
      <article
        data-testid={`benefit-card-${item.k}`}
        className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-[#A69B8F]/30 bg-white p-7 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_30px_60px_-30px_rgba(45,45,45,0.35)]"
      >
        <span className="absolute right-5 top-3 font-display text-[5rem] font-extrabold leading-none text-[#F4F0E8] transition-colors duration-500 group-hover:text-[#F26D5A]/10">
          0{i + 1}
        </span>
        <span className="relative grid h-14 w-14 place-items-center rounded-2xl bg-[#2D2D2D] text-[#F7D048] transition-[background-color,transform] duration-500 group-hover:rotate-[-8deg] group-hover:bg-[#F26D5A] group-hover:text-[#1f1f1f]">
          <Icon className="h-6 w-6" strokeWidth={2} />
        </span>
        <div className="relative mt-12">
          <h3 className="font-display text-xl font-extrabold text-[#2D2D2D] sm:text-2xl">{item.t}</h3>
          <p className="mt-3 text-sm leading-relaxed text-[#5a524a] sm:text-base">{item.d}</p>
        </div>
      </article>
    </Reveal>
  );
};

export const Benefits = () => {
  const { t: all } = useLang();
  const t = all.benefits;
  return (
  <section id="avantatges" data-testid="benefits-section" className="bg-[#FDFBF7] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-end">
        <Reveal>
          <Eyebrow>{t.eyebrow}</Eyebrow>
          <h2 className="font-display mt-5 text-4xl font-extrabold leading-[1] tracking-tight text-[#2D2D2D] sm:text-5xl">
            {t.title[0]} <span className="italic text-[#F26D5A]">{t.title[1]}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-md text-base text-[#5a524a] md:text-lg lg:ml-auto">
            {t.intro}
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => <Card key={item.k} item={{ ...item, ...t.items[i] }} i={i} />)}
      </div>
    </div>
  </section>
  );
};
